import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Interceptor global robusto para prevenir errores de navegación en el sandbox
document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement;
  const anchor = target.closest('a');
  
  if (anchor && anchor.getAttribute('href')?.startsWith('#')) {
    e.preventDefault();
    e.stopPropagation();
    const targetId = anchor.getAttribute('href')?.substring(1);
    const element = document.getElementById(targetId || '');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}, true);

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(<App />);
} else {
  console.error('No se encontró el elemento root');
}